import React, {
  AnchorHTMLAttributes,
  FC,
  HTMLAttributeAnchorTarget,
  HTMLAttributeReferrerPolicy,
  Ref,
  forwardRef,
} from 'react';

export type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string;
  className?: string;
  itemProp?: string;
  target?: HTMLAttributeAnchorTarget;
  referrerPolicy?: HTMLAttributeReferrerPolicy;
  ariaLabel?: string;
  rel?: string;
  children?: React.ReactNode;
};

// Stands in for headless_jshop's ui/Link, which wraps next/link. There is no router
// here, so this is a plain anchor — the prop surface is kept identical (including
// ariaLabel) so components port across without edits.
const Link: FC<LinkProps> = forwardRef(
  ({ href, ariaLabel, children, ...props }, ref: Ref<HTMLAnchorElement>) => {
    return (
      <a href={href} aria-label={ariaLabel} ref={ref} {...props}>
        {children}
      </a>
    );
  }
);

Link.displayName = 'Link';

export default Link;
